export const TEAMS_HIERARCHY_DATA_NAMESPACE = 'team-hierarchy';